import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { companyInfo } from '../data/mock';

const Footer = () => {
  return (
    <footer style={{
      backgroundColor: '#333333',
      color: '#fffef2',
      marginTop: 'auto'
    }}>
      <div className="container" style={{
        padding: '80px 40px 40px'
      }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '48px',
          marginBottom: '48px'
        }}>
          {/* Company Info */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_amazon-products-3/artifacts/i004pfs7_logowithr%20600%20x%20180.jpeg" 
              alt="EASY2HOME" 
              style={{
                height: '40px',
                width: 'auto',
                marginBottom: '16px',
                filter: 'brightness(0) invert(1)'
              }}
            />
            <p className="body-regular" style={{ color: '#bcbbb4', marginTop: '16px' }}>
              {companyInfo.tagline}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="heading-3" style={{ color: '#fffef2', marginBottom: '16px' }}>
              Quick Links
            </h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <Link to="/" className="body-regular" style={{ color: '#bcbbb4' }}>
                Home
              </Link>
              <Link to="/products" className="body-regular" style={{ color: '#bcbbb4' }}>
                Products
              </Link>
              <Link to="/about" className="body-regular" style={{ color: '#bcbbb4' }}>
                About Us
              </Link>
              <Link to="/contact" className="body-regular" style={{ color: '#bcbbb4' }}>
                Contact
              </Link>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="heading-3" style={{ color: '#fffef2', marginBottom: '16px' }}>
              Contact Us
            </h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Mail size={16} color="#bcbbb4" />
                <a href={`mailto:${companyInfo.email}`} className="body-regular" style={{ color: '#bcbbb4' }}>
                  {companyInfo.email}
                </a>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Phone size={16} color="#bcbbb4" />
                <a
                  href={`tel:${companyInfo.phone}`}
                  className="body-regular"
                  style={{
                    color: '#333333',
                    backgroundColor: '#f0e27a',
                    display: 'inline-block',
                    padding: '4px 10px',
                    fontWeight: '700'
                  }}
                >
                  {companyInfo.phone}
                </a>
              </div>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                <MapPin size={16} color="#bcbbb4" style={{ marginTop: '4px' }} />
                <p className="body-regular" style={{ color: '#bcbbb4' }}>
                  {companyInfo.address}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div style={{
          borderTop: '1px solid #4a4a4a',
          paddingTop: '24px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '16px'
        }}>
          <p className="body-small" style={{ color: '#bcbbb4' }}>
            © 2024 EASY2HOME. All rights reserved.
          </p>
          <div style={{ display: 'flex', gap: '24px' }}>
            <Link to="#" className="body-small" style={{ color: '#bcbbb4' }}>
              Privacy Policy
            </Link>
            <Link to="#" className="body-small" style={{ color: '#bcbbb4' }}>
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
